import { useEffect, useState } from "react"
import axios from "axios"

const Form = () => {

	const [loading, setLoading] = useState(false)
	const [submitted, setSubmitted] = useState(false)

	const [currentPage, setCurrentPage] = useState(1)

	const [data, setData] = useState({
		businessEmail: '',
		businessType: '',
		businessName: '',
		location: '',
		specificBusinessType: '',
		legalStructure: '',
		missionStatement: '',
		founder1: '',
		founder1Responsibilities: '',
		founder2: '',
		founder2Responsibilities: '',
		futureGoals: '',
		industry: '',
		uspSpecialization: '',
		businessServices: '',
		targetAudience: '',
		brandIdentity: '',
		productsAndServices: '',
		facilities: ''
	})

	const [errorMessage, setErrorMessage] = useState('')

	const businessTypes = ['Accounting', 'Agriculture', 'Antiques/Collectables', 'Arts & Crafts', 'Asset Management', 'Automotive', 'Beverages', 'Business Services', 'Child Care', 'Cleaning Services', 'Construction/Home Improvement', 'Design', 'Distributor', 'Commerce', 'Education/Training', 'Entertainmen', 'Fashion', 'Food services', 'Gardening/Landscaping', 'Health & Beauty', 'Information Technology', 'Legal services', 'Maintenance/Repair', 'Management Services', 'Manufacturing', 'Marketing Services', 'Media', 'Medical Practitioners', 'Music', 'Nightlife', 'Personal Services', 'Pet Services', 'Photography', 'Professional Services', 'Publishing', 'Recruiting & Staffing', 'Rental & Leasing', 'Research Services', 'Retail', 'Shipping & Delivery', 'Sports & Recreation', 'Sustainability', 'Toys & Hobbies', 'Transportation', 'Travel & Tourism', 'Value Added Reseller', 'Warehousing & Storage', 'Wholesale', 'Other']
	const businessIndustries = ['Extermination/Pest Control', 'Farming(Animal Production)', 'Farming(Crop Production)', 'Fishing/Hunting', 'Landscape Services', 'Lawn care Services', 'Other (Agriculture & Forestry/Wildlife)', 'Consultant', 'Employment Office Fundraisers', 'Going out of Business Sales Marketing/Advertising', 'Non Profit Organization Notary Public', 'Online Business', 'Other (Business & Information)', 'Publishing Services', 'Record Business', 'Retail Sales', 'Technology Services Telemarketing', 'Travel Agency', 'Video Production', 'AC & Heating', 'Architect', 'Building Construction', 'Building Inspection', 'Concrete Manufacturing', 'Contractor', 'Engineering/Drafting', 'Equipment Rental', 'Other (Construction/Utilities/Contracting)', 'Plumbing', 'Remodeling', 'Repair/Maintenance', 'Child Care Services College/Universities', 'Cosmetology School', 'Elementary & Secondary Education GED Certification', 'Other (Education) Private School Real Estate School', 'Technical School', 'Trade School', 'Tutoring Services', 'Vocational School', 'Accountant', 'Auditing', 'Bank/Credit Union', 'Bookkeeping', 'Cash Advances', 'Collection Agency', 'Insurance Investor', 'Other (Finance & Insurance)', 'Pawn Brokers', 'Tax Preparation', 'Alcohol/Tobacco Sales', 'Alcoholic Beverage Manufacturing', 'Bakery', 'Caterer', 'Food/Beverage', 'Manufacturing', 'Grocery/Convenience', 'Store(Gas Station)', 'Grocery/Convenience', 'Store(No Gas Station)', 'Hotels/Motels(Casino)', 'Hotels/Motels(No Casino)', 'Mobile Food Services', 'Other (Food & Hospitality)', 'Restaurant/Bar', 'Specialty Food(Fruit/Vegetables)', 'Specialty Food(Meat)', 'Specialty Food(Seafood)', 'Tobacco Product Manufacturing', 'Truck Stop', 'Vending Machine', 'Auctioneer', 'Boxing/Wrestling', 'Casino/Video', 'Gaming', 'Other (Gaming)', 'Racetrack', 'Sports Agent', 'Acupuncturist', 'Athletic Trainer', 'Child/Youth Services', 'Chiropractic Office', 'Dentistry', 'Electrolysis', 'Embalmer', 'Emergency Medical Services', 'Emergency Medical Transportation', 'Hearing Aid Dealers', 'Home Health Services', 'Hospital', 'Massage Therapy', 'Medical Office', 'Mental Health Services', 'Non Emergency Medical Transportation', 'Optometry', 'Other (Health Services)', 'Pharmacy', 'Physical Therapy', 'Physicians Office', 'Radiology', 'Residential Care Facility', 'Speech/Occupational Therapy', 'Substance Abuse Services', 'Veterinary Medicine', 'Vocational Rehabilitation', 'Wholesale Drug Distribution', 'Automotive Part Sales', 'Car Wash/Detailing', 'Motor Vehicle Rental Motor', 'Vehicle Repair', 'New Motor Vehicle Sales', 'Other (Motor Vehicle)', 'Recreational Vehicle Sales', 'Used Motor Vehicle Sales', 'Conservation Organizations', 'Environmental Health', 'Land Surveying', 'Oil & Gas Distribution', 'Oil & Gas Extraction/Production', 'Other (Natural Resources/Environmental)', 'Pipeline', 'Water Well Drilling', 'Other(Business Type Not Listed)', 'Animal Boarding', 'Barber Shop', 'Beauty Salon', 'Cemetery', 'Diet Center', 'Dry cleaning/Laundry', 'Entertainment/Party Rentals', 'Event Planning', 'Fitness Center', 'Florist', 'Funeral Director', 'Janitorial/Cleaning Services', 'Massage/Day Spa', 'Nail Salon', 'Other (Personal Services)', 'Personal Assistant', 'Photography', 'Tanning Salon', 'Home Inspection', 'Interior Design', 'Manufactured Housing', 'Mortgage Company', 'Other (Real Estate & Housing)', 'Property Management', 'Real Estate Broker/Agent', 'Warehouse/Storage', 'Attorney', 'Bail Bonds', 'Court Reporter', 'Drug Screening', 'Locksmith', 'Other (Safety/Security & Legal)', 'Private Investigator', 'Security Guard', 'Security System Services', 'Air Transportation', 'Boat Services', 'Limousine Services', 'Other (Transportation)', 'Taxi Services', 'Towing', 'Truck Transportation(Fuel)', 'Truck Transportation(Non Fuel)']
	const businessFacilities = ['Office', 'Hotel', 'Restaurant', 'Store/Shop', 'Hospital/Health Facility', 'Laboratory', 'School/Campus', 'Apartment', 'Factory', 'Warehouse', 'Other']
	const businessLegalStructures = ['Sole Proprietor', 'LLC', 'Corporation', 'Partnership', 'Non-Profit']

	const handleInputChange = (e, fieldName) => {
		setData(prevData => ({
			...prevData,
			[fieldName]: e.target.value
		}))
	}

	const submitForm = () => {
    const form = document.getElementById('business_form')
    if (form) {
			setLoading(true)
      form.submit()

			setTimeout(() => {
				handleSubmit()
			}, 2000)
    }
  }

	const handleSubmit = async () => {
		setErrorMessage('')
		if(
			data.productsAndServices &&
			data.facilities
		) {

			try {
				const response = await axios.post('https://eoi9uwenelxb7bk.m.pipedream.net', data)
				
				// Handle success case
				if(response.status === 200) {
					setLoading(false)
					setSubmitted(true)

					// const {
					// 	generateBusinessOverview,
					// 	generateMarketAnalysis,
					// 	generateProductsAndServices,
					// 	generateMarketingAndSalesStrategies,
					// 	generateOperationsPlan,
					// 	generateFinancialPlan,
					// 	generateBusinessSummary,
					// 	generateAppendix,
					// } = response.data

					setData({
						businessName: '',
						businessType: '',
						specificBusinessType: '',
						location: '',
						legalStructure: '',
						missionStatement: '',
						founder1: '',
						founder1Responsibilities: '',
						founder2: '',
						founder2Responsibilities: '',
						futureGoals: '',
						industry: '',
						uspSpecialization: '',
						businessServices: '',
						targetAudience: '',
						brandIdentity: '',
						productsAndServices: '',
						facilities: '',
						isCoOwner: '',
					})

					console.log(response.data)

				} else {
					// Handle any non-200 response here
					setLoading(false)
					alert('There was a problem submitting the form. Please try again.')
				}
	
			} catch(error) {
				// Handle errors from the request
				setLoading(false)
				alert('There was an error submitting the form. Please try again.')
			}
	
		} else {
			setErrorMessage('Please fill required fields.')
		}
	}

	const handlePrevPage = () => {
		if(currentPage !== 1) {
			setCurrentPage(currentPage-1)
		}
	}
	
	const handleNextPage = () => {
		switch(currentPage) {
			case 1:
				if(
					data.businessName &&
					data.businessType &&
					data.specificBusinessType
				) {
					setErrorMessage('')
					setCurrentPage(2)
					break;
				} else {
					setErrorMessage('Please fill required fields.')
					break;
				}
			case 2:
				if(
					data.missionStatement &&
					data.location &&
					data.legalStructure
					) {
					setErrorMessage('')
					setCurrentPage(3)
					break;
				} else {
					setErrorMessage('Please fill required fields.')
					break;
				}
			case 3:
				if(data.isCoOwner === 'YES') {
					if(
						data.founder1 &&
						data.founder1Responsibilities &&
						data.founder2 &&
						data.founder2Responsibilities
					) {
						setErrorMessage('')
						setCurrentPage(4)
						break;
					} else {
						setErrorMessage('Please fill required fields.')
						break;
					}
				} else {
					if(
						data.founder1 &&
						data.founder1Responsibilities
					) {
						setErrorMessage('')
						setCurrentPage(4)
						break;
					} else {
						setErrorMessage('Please fill required fields.')
						break;
					}
				}
			case 4:
				if(
					data.futureGoals
				) {
					setErrorMessage('')
					setCurrentPage(5)
					break;
				} else {
					setErrorMessage('Please fill required fields.')
					break;
				}
			case 5:
				if(
					data.businessServices &&
					data.targetAudience &&
					data.brandIdentity
				) {
					setErrorMessage('')
					setCurrentPage(6)
					break;
				} else {
					setErrorMessage('Please fill required fields.')
					break;
				}
		}
	}

	const handleSubmitAndRedirectToPayment = () => {
		window.location.href = "https://buy.stripe.com/aEU29G0JB6ys7Pq8wz"
	}

	return (
		<div className="flex flex-col w-full min-h-screen">
			<div className="form-wrapper section-full wf-section">
				{!submitted ?
					<>
						<div className="flex flex-col w-full max-w-[1000px] bg-white p-[50px] rounded-2xl shadow-2xl shadow-gray-200">
							<div className="w-full text-center mb-2">
								<p className="font-medium">STEP {currentPage} OF 6</p>
							</div>
							<p className="section-title">Tell us about your business</p>

							{
								currentPage === 1
								&&
								<div>
									{/* Email */}
									<label className="form-input-wrapper">
										<p className="form-input-label">Enter you business email</p>
										<input className="input-field" type="email" value={data.businessEmail} onChange={(e) => handleInputChange(e, 'businessEmail')} />
									</label>

									{/* Business name */}
									<label className="form-input-wrapper">
										<p className="form-input-label">Your business name</p>
										<input className="input-field" type="text" value={data.businessName} onChange={(e) => handleInputChange(e, 'businessName')} />
										{/* <p className="form-input-hint">(Hint: This is how it is listed on your bank account and/or incorporation papers)</p> */}
									</label>

									{/* Business type */}
									<label className="form-input-wrapper">
										<p className="form-input-label">Select your business type</p>
										<select className="input-field appearance-none cursor-pointer" value={data.businessType} onChange={(e) => handleInputChange(e, 'businessType')}>
											<option value="default">Please specify</option>
											{
												businessTypes.map((businessType) => (
													<option value={businessType} key={`${businessType}${Math.random()}`}>{businessType}</option>
												))
											}
										</select>
									</label>

									{/* Specific business type */}
									<label className="form-input-wrapper">
										<p className="form-input-label">In 2-3 words, tell us your specific business</p>
										<input className="input-field" type="text" value={data.specificBusinessType} onChange={(e) => handleInputChange(e, 'specificBusinessType')} />
										{/* <p className="form-input-hint">(Hint: Financial Advisor or Car Wash or Tax Preparer or Nail Salon.)</p> */}
									</label>
								</div>
							}

							{
								currentPage === 2
								&&
								<div>
									{/* Location */}
									<label className="form-input-wrapper">
										<p className="form-input-label">What city and state is your business located in?</p>
										<input className="input-field" type="text" value={data.location} onChange={(e) => handleInputChange(e, 'location')} />
									</label>

									{/* Legal structure */}
									<label className="form-input-wrapper">
										<p className="form-input-label">Select the legal structure of your business?</p>
										<select className="input-field appearance-none cursor-pointer" value={data.legalStructure} onChange={(e) => handleInputChange(e, 'legalStructure')}>
											<option value="default">Please specify</option>
											{
												businessLegalStructures.map((businessLegalStructure) => (
													<option value={businessLegalStructure} key={`${businessLegalStructure}${Math.random()}`}>{businessLegalStructure}</option>
												))
											}
										</select>
									</label>
									{/* Mission statement */}
									<label className="form-input-wrapper">
										<p className="form-input-label">What is the mission or purpose of your business?</p>
										<textarea className="input-field h-[300px] resize-none" type="text" value={data.missionStatement} onChange={(e) => handleInputChange(e, 'missionStatement')} />
									</label>
								</div>
							}

							{
								currentPage === 3
								&&
								<div>
									{/* Founder 1 */}
									<label className="form-input-wrapper">
										<p className="form-input-label">Business owner's first and last name</p>
										<input className="input-field" type="text" value={data.founder1} onChange={(e) => handleInputChange(e, 'founder1')} />
									</label>

									{/* Founder 1 responsibilities */}
									<label className="form-input-wrapper">
										<p className="form-input-label">What duties will the owner be responsible for?</p>
										<input className="input-field" type="text" value={data.founder1Responsibilities} onChange={(e) => handleInputChange(e, 'founder1Responsibilities')} />
									</label>

									<label className="form-input-wrapper">
										<p className="form-input-label">Is there a co-owner?</p>
										<div className="flex">
											<span className={`mr-2 ${data.isCoOwner === 'YES' ? 'option-selector option-selector-selected' : 'option-selector'}`} onClick={() => handleInputChange({target: { value: 'YES' }}, 'isCoOwner')}>YES</span>
											<span className={`mr-2 ${data.isCoOwner === 'NO' ? 'option-selector option-selector-selected' : 'option-selector'}`} onClick={() => handleInputChange({target: { value: 'NO' }}, 'isCoOwner')}>NO</span>
										</div>
									</label>

									{
										data.isCoOwner === 'YES'
										&&
										<>
											{/* Founder 2 */}
											<label className="form-input-wrapper">
												<p className="form-input-label">Co-owner's first and last name?</p>
												<input className="input-field" type="text" value={data.founder2} onChange={(e) => handleInputChange(e, 'founder2')} />
											</label>

											{/* Founder 2 responsibilities */}
											<label className="form-input-wrapper">
												<p className="form-input-label">What will the co-owner be responsible for?</p>
												<input className="input-field" type="text" value={data.founder2Responsibilities} onChange={(e) => handleInputChange(e, 'founder2Responsibilities')} />
											</label>
										</>
									}
								</div>
							}


							{
								currentPage === 4
								&&
								<div>
									{/* Future goals */}
									<label className="form-input-wrapper">
										<p className="form-input-label">What does your business hope to accomplish in the future?</p>
										<input className="input-field" type="text" value={data.futureGoals} onChange={(e) => handleInputChange(e, 'futureGoals')} />
									</label>

									{/* Industry */}
									{/* <label className="form-input-wrapper">
										<p className="form-input-label">Industry</p>
										<select className="input-field appearance-none cursor-pointer" value={data.industry} onChange={(e) => handleInputChange(e, 'industry')}>
											<option value="default">Please specify</option>
											{
												businessIndustries.map((businessIndustry) => (
													<option value={businessIndustry} key={`${businessIndustry}${Math.random()}`}>{businessIndustry}</option>
												))
											}
										</select>
									</label> */}

									{/* USP/Specialization */}
									{/* <label className="form-input-wrapper">
										<p className="form-input-label">USP/Specialization</p>
										<select className="input-field appearance-none cursor-pointer" value={data.uspSpecialization} onChange={(e) => handleInputChange(e, 'uspSpecialization')}>
											<option value="default">Please specify</option>
											{
												businessIndustries.map((businessIndustry) => (
													<option value={businessIndustry} key={`${businessIndustry}${Math.random()}`}>{businessIndustry}</option>
												))
											}
										</select>
									</label> */}
								</div>
							}

							{
								currentPage === 5
								&&
								<div>
									{/* Business services */}
									<label className="form-input-wrapper">
										<p className="form-input-label">What service does your business provide?</p>
										<input className="input-field" type="text" value={data.businessServices} onChange={(e) => handleInputChange(e, 'businessServices')} />
									</label>

									{/* Target Audience */}
									<label className="form-input-wrapper">
										<p className="form-input-label">Who is your target audience?</p>
										<input className="input-field" type="text" value={data.targetAudience} onChange={(e) => handleInputChange(e, 'targetAudience')} />
										{/* <p className="form-input-hint">(Hint: Gender? Age? Interest? Income? Needs?)</p> */}
									</label>

									{/* Describe your brand identity in brief */}
									<label className="form-input-wrapper">
										<p className="form-input-label">Describe Your Brand Identity in brief</p>
										<input className="input-field" type="text" value={data.brandIdentity} onChange={(e) => handleInputChange(e, 'brandIdentity')} />
										{/* <p className="form-input-hint">(Hint: What is brand identity? A brand identity is made up of what your brand says, what your values are, how you communicate your product, and what you want people to feel when they interact with your company. Essentially, your brand identity is the personality of your business and a promise to your customers.)</p> */}
									</label>
								</div>
							}

							{
								currentPage === 6
								&&
								<div>
									{/* Describe products and services */}
									<label className="form-input-wrapper">
										<p className="form-input-label">Describe your products and services</p>
										<input className="input-field" type="text" value={data.productsAndServices} onChange={(e) => handleInputChange(e, 'productsAndServices')} />
									</label>

									{/* Specify facilities */}
									<label className="form-input-wrapper">
										<p className="form-input-label">Select your facility type</p>
										<select className="input-field appearance-none cursor-pointer" value={data.facilities} onChange={(e) => handleInputChange(e, 'facilities')}>
											<option value="default">Please specify</option>
											{
												businessFacilities.map((facility) => (
													<option value={facility} key={`${facility}${Math.random()}`}>{facility}</option>
												))
											}
										</select>
									</label>
								</div>
							}

							<div className="ml-auto mr-auto mt-[30px] flex">
								{
									errorMessage
									&&
									<p className="text-red-500 text-[22px] font-medium">{errorMessage}</p>
								}
							</div>

							<div className="ml-auto mr-auto mt-[50px] flex">
								{
									currentPage !== 1
									&&
									<button className="mr-4 mt-2 styled-button-outlined w-full" onClick={handlePrevPage}>Back</button>
								}
								{
									currentPage !== 6
									&&
									<button className="mt-2 styled-button w-full" onClick={handleNextPage}>Next</button>
								}
								{
									currentPage === 6
									&&
									<button className="mt-2 styled-button w-full" onClick={submitForm}>Submit</button>
								}
							</div>
						</div>

					</>
					:
					<div className="flex flex-col justify-center items-center">
						<span className="text-[35px] font-bold">Your business plan is ready!</span>
						{/* <input className="mt-8 input-field" placeholder="Enter you business email" type="text" value={data.businessEmail} onChange={(e) => handleInputChange(e, 'businessEmail')} /> */}
						<span className="mt-4 text-[22px] font-medium">It is available to download for a small administrative fee.</span>
						<span className="mt-4 text-[16px] font-medium text-center">You will be redirected to <b>Stripe</b> for payment. <br />Please use the same <b>email</b> and <b>business name</b> on <b>Stripe</b>.</span>

						<button className="mt-6 styled-button" disabled={!data.businessEmail} onClick={handleSubmitAndRedirectToPayment}>Proceed to Checkout</button>
					</div>
				}
			</div>

			<form
				id='business_form'
				method="POST"
				action="https://forms.hubspot.com/uploads/form/v2/6710643/ec34489d-c37b-49f1-86f9-f87dcb265226"
				hidden
			>
				<input type="hidden" name="email" value={data.businessEmail} />
				<input type="hidden" name="company" value={data.businessName} />
				<input type="hidden" name="industry" value={data.businessType} />
				<input type="hidden" name="specific_business" value={data.specificBusinessType} />
				<input type="hidden" name="city" value={data.location.split(',')?.[0]} />
				<input type="hidden" name="state" value={data.location.split(',')?.[1]} />
				<input type="hidden" name="legal_structure" value={data.legalStructure} />
				<input type="hidden" name="firstname" value={data.founder1.split(/\s/)?.[0]} />
				<input type="hidden" name="lastname" value={data.founder1.split(/\s/)?.[1]} />
				<input type="hidden" name="role_owner" value={data.founder1Responsibilities} />
				<input type="hidden" name="co_owner_name" value={data.founder2} />
				<input type="hidden" name="role_co_owner" value={data.founder2Responsibilities} />
				<input type="hidden" name="businessgoals" value={data.futureGoals} />
				<input type="hidden" name="usp_specialization" value={data.uspSpecialization} />
				<input type="hidden" name="business_services" value={data.businessServices} />
				<input type="hidden" name="targetmarket" value={data.targetAudience} />
				<input type="hidden" name="brand_identity" value={data.brandIdentity} />
				<input type="hidden" name="productdescription" value={data.productsAndServices} />
				<input type="hidden" name="specify_facilities" value={data.facilities} />
			</form>
		</div>
	)
}

export default Form